
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generative-ai-services",
      function () {
        return require("private-next-pages/generative-ai-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/generative-ai-services"])
      });
    }
  